module.exports = __webpack_public_path__ + "assets/img/pyramidal-fruit.408e0668.png";